import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import NotificationBadge from './NotificationBadge'
import NotificationMenu from './NotificationMenu'
import useNotificationContext from '../../hooks/use-notification-context'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * Component provides a notification-badge-icon by which a menu can be opened
 */
const NotificationMenuBadge: React.VFC = () => {
  const location = useLocation()
  const [isNotificationPage, setIsNotificationPage] = useState(false)

  const [notificationAnchor, setNotificationAnchor] = useState<HTMLButtonElement | null>(null)
  const { loadUnreadNotificationsCount, unreadNotificationsCount } = useNotificationContext()

  useEffect(() => {
    setIsNotificationPage(location.pathname === '/notifications')
  }, [location.pathname])

  useEffect(() => {
    loadUnreadNotificationsCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onNotificationBadge = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setNotificationAnchor(event.currentTarget)
  }

  const handleNotificationsClose = (): void => {
    setNotificationAnchor(null)
  }

  return (
    <Box>
      <NotificationBadge onClick={onNotificationBadge} unreadNotificationsCount={unreadNotificationsCount} isNotificationPage={isNotificationPage} />
      {!isFlowTheme && <NotificationMenu notificationAnchor={notificationAnchor} onClose={handleNotificationsClose} />}
    </Box>
  )
}

export default NotificationMenuBadge
